import { Frown } from '@pretamanger/component-library'
import { Container, LabelEmptyProducts, CustomFrown } from './styles'
import { useGetTranslation } from '#src/auth/my-account-page/hooks/use-get-translation'

const EmptyProducts = () => {
  const getTranslation = useGetTranslation()
  const label = getTranslation('filter-allergens-empty-state')
  return (
    <Container>
      <CustomFrown />
      <LabelEmptyProducts>{label}</LabelEmptyProducts>
    </Container>
  )
}

export default EmptyProducts
